import {
  MyAccountTheme,
  MyAccountGenericInputClasses,
} from '@dxp-module/themes'
import makeStyles from '@mui/styles/makeStyles'

const phoneWithPrefixStyles = makeStyles<
  MyAccountTheme,
  object,
  MyAccountGenericInputClasses
>(
  ({ palette, breakpoints, typography }) => ({
    root: {
      paddingLeft: 2,
      marginRight: 15,
      borderRadius: 0,
      background: palette.common.white,
      '& legend': {
        display: 'none',
      },
      '& fieldset': {
        top: 0,
      },
      '&.Mui-disabled': {
        backgroundColor: palette.action.disabledBackground,
      },
      display: 'flex',
      alignItems: 'stretch',
      padding: '2px 0',
    },
    fieldWrapper: {
      position: 'relative',
      width: '100%',
    },
    input: {
      width: '100%',
      '& input': {
        width: '100%',
        height: 'fit-content',
        '&.Mui-disabled': {
          WebkitTextFillColor: palette.common.black,
        },
      },
    },
    phoneInput: {
      '& input': {
        marginLeft: 12,
      },
    },
    errorText: {
      fontSize: 'inherit',
    },
    notchedOutline: {
      borderRadius: 0,
      borderWidth: 1,
      '& span': {
        display: 'none',
      },
    },
    focused: {
      borderColor: palette.primary.main,
    },
    inputError: {
      borderColor: palette.error.main,
    },
    dateCalendar: {
      '& span': {
        color: palette.primary.main,
      },

      [breakpoints.down('sm')]: {
        paddingRight: 10,
      },
    },
    helperTextError: {
      margin: '4px 0',
      color: palette.error.main,
    },
    label: {
      color: palette.text.primary,
      marginBottom: 6,
      lineHeight: '20px',
    },
    labelAsterisk: {},
    phonePrefix: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      width: 48,
      backgroundColor: palette.action.disabledBackground,
      fontSize: typography.fontMD,
    },
    noOptions: {
      [breakpoints.down('md')]: {
        fontSize: typography.fontXS,
      },
      [breakpoints.down('sm')]: {
        fontSize: typography.fontXS,
      },
    },
    inputNoLabel: {},
    tooltipIcon: {
      fontSize: 20,
    },
    labelContainer: {},
    startAdornment: {
      height: 'auto',
      maxHeight: 'unset',
    },
    disabled: {},
  }),
  { name: 'MyAccount_PhoneWithPrefix' }
)

export default phoneWithPrefixStyles
